import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import {
  BUDGET_MODULE_PATHS,
  SELECTED_BUDGET_MODULE_YEAR_KEY,
} from "../constants/budgetModule";
import { useAuth } from "../state/AuthContext";
import { isAccountantUser } from "../utils/userRole";

const LegacyWorkspaceRedirectPage = () => {
  const { year = "" } = useParams();
  const { user } = useAuth();

  useEffect(() => {
    if (year) {
      window.localStorage.setItem(SELECTED_BUDGET_MODULE_YEAR_KEY, year);
    }
  }, [year]);

  return (
    <Navigate
      to={
        isAccountantUser(user)
          ? BUDGET_MODULE_PATHS.planner
          : BUDGET_MODULE_PATHS.mapping
      }
      replace
    />
  );
};

export default LegacyWorkspaceRedirectPage;
